import { json } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import { client } from "../models/contentful.server";
import ComponentBuilder from "@/components/ComponentBuilder";

export async function loader() {
    return json(await client.getPage("Contact"))
}

export const meta = ({data} : any) => {
	const {seoMetadata} = data;
	return {
		title: seoMetadata?.title || 'Cannoli - Contact us',
		description: seoMetadata?.description,
		"og:image": `${seoMetadata?.ogImage.url}`
	}
}

export default function Contact() {
	const { blocksCollection } = useLoaderData();
    return (
        <>
			<ComponentBuilder blocks={blocksCollection?.items} />
  		</>
    )
}